const ProfileTypes = {
  /** ***************** UPDATE PASSWORD START  *********************** */
  UPDATE_PASSWORD_START: "update_password_start",
  UPDATE_PASSWORD_SUCCESS: "update_password_success",
  UPDATE_PASSWORD_FAILURE: "update_password_failure",
  UPDATE_PASSWORD_RESPONSE_RESET: "update_password_response_reset",
  UPDATE_PASSWORD_RESPONSE_CHANGED: "update_password_response_changed",
  /** ***************** UPDATE PASSWORD END *********************** */

  /*****************  UPDATE PROFILE   IMAGE  DETAILS START  *******************/
  UPDATE_PROFILE_IMAGE_DETAILS_START: "update_profile_image_details_start",
  UPDATE_PROFILE_IMAGE_DETAILS_SUCCESS: "update_profile_image_details_success",
  UPDATE_PROFILE_IMAGE_DETAILS_FAILURE: "update_profile_image_details_failure",
  UPDATE_PROFILE_IMAGE_DETAILS_RESPONSE_RESET:
    "update_profile_image_details_response_reset",
  UPDATE_PROFILE_IMAGE_DETAILS_RESPONSE_CHANGED:
    "update_profile_image_details_response_changed",
  /*****************  UPDATE PROFILE   IMAGE  DETAILS END  *******************/
};
export default ProfileTypes;
